import React from "react";
import FriendlyDate from "./FriendlyDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";

export default function WatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <div className="col-6 p-0 mt-3">
        <h1>{props.info.city}</h1>
        <ul>
          <li>
            <FriendlyDate date={props.info.date} />
          </li>
          <li className="text-capitalize">{props.info.description}</li>
        </ul>
      </div>
      <div className="row">
        <div className="col-6">
          <div className="float-left">
            <WeatherIcon iconNum={props.info.iconUrl} />
          </div>
          <WeatherTemperature temp={props.info.temperature} />
        </div>
        <div className="row">
          <ul>
            <li>Humidity: {props.info.humidity}%</li>
            <li>Wind: {props.info.wind}km/h</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
